import { Divider, IconButton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { Delete, Edit, Visibility } from "@mui/icons-material";
import moment from "moment";
import Table from "components/Table";
import { StyledSpan } from "./styles";
import { useState } from "react";
import EditFyaNotice from "./fya/EditFyaNotice";
import { useMutation, useQueryClient } from "react-query";
import { snack } from "components/toast";
import { handleError } from "utils/handleError";
import { useConfirm } from "context/ConfirmDialog";
import { deleteFyaNotice } from "api/services/automation/config";

type Props = {
  data: any;
  clientName: any
};

function EproceedingNoticesList({ data, clientName }: Props) {
  const [open, setOpen] = useState(false)
  const [editedItem, setEditedItem] = useState({})
  const conform = useConfirm()

  let columns = [
    {
      key: "documentIdentificationNumber",
      title: "DIN",
    },
    {
      key: "issuedOn",
      title: "Issued On",
      render: (item: any) => (<Typography>{item?.issuedOn ? moment(item?.issuedOn).format('DD MMM YYYY HH:mm') : "--"}</Typography>)
    },
    {
      key: "responseDueDate",
      title: "Response Due Date",
      render: (item: any) => (<Typography>{item?.responseDueDate ? moment(item?.responseDueDate).format('DD MMM YYYY HH:mm') : "--"}</Typography>)

    },
    {
      key: "",
      title: "Total Responses",
      render: (item: any) => (<Typography>{item?.responses?.length ? item?.responses?.length : "0"}</Typography>)

    },
    {
      key: "id",
      title: "Created Type",
      render: (v) =>
        <Box>
          {v?.createdType === "MANUAL" ? (
            <StyledSpan bgColor="#f2e6ff">Manual</StyledSpan>
          ) : (
            <StyledSpan bgColor="#b3ecff">Portal</StyledSpan>
          )}
        </Box>
    },
    {
      key: "id",
      title: "Actions",
      render: (rowData: any) => <Actions data={rowData} />,
    },

  ];

  const Actions = (props: any) => {
    const navigate = useNavigate();
    const queryClient = useQueryClient()
    const handlerowClick = () => {
      navigate(`/atom-pro/income-tax/proceeding-action/notice-fya/${props.data?.id}`);
    };

    const handleEditClick = () => {
      console.log("Edit Row Click")
      setEditedItem(props?.data)
      setOpen(true)
    }

    const { mutate, isLoading } = useMutation(deleteFyaNotice, {
      onSuccess: () => {
        snack.success("Fya Notice Deleted")
        queryClient.invalidateQueries("e-proceeding")

      },
      onError: (error) => {
        snack.error(handleError(error))
      }
    })
    const handleDeleteClick = () => {
      conform({
        msg: "Are you sure want to delete this Notice?",
        action() {
          mutate({ id: props.data?.id })
        },
      })
    }
    return (
      <>
        <Box display="flex" gap={1}>
          <>
            <IconButton onClick={handlerowClick} size="small">
              <Visibility />
            </IconButton>

            {props?.data?.createdType === "MANUAL" && (<>
              <IconButton onClick={handleEditClick} size="small">
                <Edit />
              </IconButton>
              <IconButton onClick={handleDeleteClick} size="small">
                <Delete />
              </IconButton>
            </>)}
          </>
        </Box>
      </>
    );
  };

  return (

    <Box m={1}>
      <Table
        data={data || []}
        sx={{ height: "300px" }}
        columns={columns}
      />

      <Divider />
      <EditFyaNotice open={open} setOpen={setOpen} state={editedItem} clientName={clientName} />
    </Box>
  );
}

export default EproceedingNoticesList;
